import { create } from 'zustand';

/** Matches yodlee-id-portal Toast payloads (see Settings.jsx, Support.jsx, Dashboard.jsx). */
export type AppToastPayload = {
  variant?: 'success' | 'error';
  placement?: 'top' | 'bottom';
  title: string;
  message?: string;
};

type AppToastState = {
  toast: AppToastPayload | null;
  showToast: (payload: AppToastPayload) => void;
  dismissToast: () => void;
};

export const useAppToastStore = create<AppToastState>(set => ({
  toast: null,
  showToast: payload => set({ toast: payload }),
  dismissToast: () => set({ toast: null }),
}));
